module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "List"
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return (index < _vm.Show) ? _c('li', [_c('div', {
      staticClass: "title",
      class: {
        time: _vm.ShowTime
      }
    }, [(_vm.name !== 'jys') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'wz',
          params: {
            ret: _vm.name,
            nr: item.value
          }
        }
      }
    }, [_vm._v(_vm._s(item.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.name === 'jys') ? _c('a', {
      attrs: {
        "href": item.jump
      }
    }, [_vm._v(_vm._s(item.title) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.ShowTime) ? _c('div', {
      staticClass: "rq"
    }, [_vm._v(_vm._s(item.ctime))]) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), _c('ShowMore', {
    attrs: {
      "listall": _vm.list.length,
      "listshow": _vm.Show,
      "count": _vm.count
    },
    on: {
      "update:listshow": function($event) {
        _vm.Show = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f131328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/List.vue
// module id = 887
// module chunks = 2